// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyBiLifetimeMaximum {
    static getAttributeTypeMap() {
        return PharmacyBiLifetimeMaximum.attributeTypeMap;
    }
}
PharmacyBiLifetimeMaximum.discriminator = undefined;
PharmacyBiLifetimeMaximum.additionalProperties = false;
PharmacyBiLifetimeMaximum.attributeTypeMap = [
    {
        "name": "amount",
        "baseName": "amount",
        "type": "string"
    },
    {
        "name": "exists",
        "baseName": "exists",
        "type": "string"
    },
    {
        "name": "met",
        "baseName": "met",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyBiLifetimeMaximum.js.map